import { compose } from 'recompose';

import { connect } from 'react-redux';

import { withTranslation } from 'react-i18next';
import { selectors as settingsSelectors } from 'state/settings';

import FaqsWithMarkup from 'components/ModalFaqs/Sections/FaqsWithMarkup/component';

const enhance = compose(
  withTranslation('Faqs'),
  connect(
    (state) => ({
      country: settingsSelectors.getCountrySettings(state),
    }),
    {}
  )
);

export default enhance(FaqsWithMarkup);
